import { useTranslation } from "react-i18next";

export const AboutReginaPacis = () => {
    const { t } = useTranslation("about");

    return (
        <div className="bg-card p-4 rounded-md text-lg shadow-xl ">
            <div className="flex flex-col justify-center items-center rounded-md ">
                <h1 className="text-2xl font-bold text-center uppercase text-gray-700">{t("aboutPage.aboutResidentie.title")}</h1>
                <div className="w-[415px] mb-4 border-2  border-b-[#bb9f82] " />
            </div>

            <div className="ml-8">
                <ul className="list-disc">
                    {
                        t("aboutPage.aboutResidentie.details", { returnObjects: true }).map((item, index) => (
                            <li key={index}>
                                {item}
                            </li>))
                    }
                </ul>
            </div>
        </div>
    )
}